import moment from "moment";
import { axiosApi } from "./apiEnviornment";

export async function getCoordinates(point, placeId) {
  const data = await axiosApi(
    "GET",
    `/map/get-coordinates/${placeId}/${point}`
  );
  return data;
}

export async function createSale(body) {
  const response = await axiosApi("POST", `/auth/booking`, { ...body });
  return response;
}


export async function getPrice() {
  const response = await axiosApi(
    "GET",
    `/auth/setting/66c9fa4d5c64f811eecdf23e`
  );
  return response.data;
}

export function getBookedJobs(date) {
  const updatedDate = moment(date).format("DD-MMM-YYYY");
  return axiosApi("GET", `/auth/booking/${updatedDate}`);
}
